import { useMobileClassNameEffect } from '../effects/adaptive-effects';

import Box from '@mui/material/Box';
import type { BoxProps } from '@mui/material/Box/Box';
import UniCreditTypography from '../uni-credit-typography';

import './uni-credit-informational-content.scss';
import './uni-credit-informational-content-mobile.scss';

export type UniCreditInformationalContentProps = {
  icon?: string,
  title?: string,
} & BoxProps;

export default function UniCreditInformationalContent({
  className,
  icon,
  title,
  children,
  ...props
}: UniCreditInformationalContentProps) {
  const mobileClassName = useMobileClassNameEffect();

  return (
    <Box className={`uni-credit-informational-content ${className || ''} ${mobileClassName}`} {...props}>
      {icon && (
        <img src={icon} />
      )}

      <UniCreditTypography type='h1-bold' color='k10'>
        {title}
      </UniCreditTypography>

      {children}
    </Box>
  );
}
